var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5292_71368)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.523438,
    width: 40.1803,
    height: 39.4754,
    rx: 8.45902,
    fill: "#1E1850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12573 30.4167V14.5484C9.12573 10.7953 12.171 7.75 15.9241 7.75H19.8089",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7926 12.8008V26.3975C31.7926 29.1629 29.5374 31.4181 26.772 31.4181H15.3152",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 20.1602L29.4426 20.1485",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9622 11.6284L20.9273 28.6804",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5292_71368"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.523438,
    width: 40.1803,
    height: 39.4754,
    rx: 8.45902,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDark);
export default __webpack_public_path__ + "static/media/addDark.11779e5790729635f2ee3bf4092ff8c4.svg";
export { ForwardRef as ReactComponent };